import classNames from 'classnames';
import { forwardRef, type CSSProperties, type MouseEvent, type ReactNode } from 'react';
import styles from './FJHoverBoardGradation.module.less';

interface FJHoverBoardGradationProps {
    /** 是否显示内边框 */
    isShowInBorder?: boolean;
    active?: boolean;
    children?: ReactNode;
    borderRadius?: number;
    className?: string;
    contentClassName?: string;
    style?: CSSProperties;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    onMouseEnter?: (e: MouseEvent<HTMLDivElement>) => void;
    onMouseLeave?: (e: MouseEvent<HTMLDivElement>) => void;
    selectBgColor?: string;
    id?: string;
    borderWidth?: number;
}

const FJHoverBoardGradation = forwardRef<HTMLDivElement, FJHoverBoardGradationProps>(function FJHoverBoardGradation(
    {
        active,
        children,
        borderRadius = 10,
        isShowInBorder = false,
        className,
        contentClassName,
        style,
        onClick,
        onMouseEnter,
        onMouseLeave,
        selectBgColor = '#f3f3f7',
        id,
        borderWidth = 2,
    },
    ref,
) {
    const rootStyle = {
        ...style,
        '--border-radius': `${borderRadius}px`,
        '--border-content-radius': `${borderRadius - 2}px`,
        '--border-width': `${borderWidth}px`,
        '--border-width-double': `${borderWidth * 2}px`,
    } as CSSProperties;

    const contentStyle = {
        '--select-bg-color': selectBgColor,
    } as CSSProperties;

    return (
        <div
            ref={ref}
            className={classNames(styles.box, className, active && styles.active, styles.hover)}
            style={rootStyle}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            id={id}
        >
            {isShowInBorder ? <div className={styles.in_border} /> : null}
            <div
                className={classNames(
                    styles.content,
                    isShowInBorder && styles.show_in_border,
                    active && isShowInBorder && styles.show_in_border_active,
                    contentClassName,
                )}
                style={contentStyle}
            >
                {children}
            </div>
        </div>
    );
});

export default FJHoverBoardGradation;
